import * as React from 'react';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import './RoleManagementStyling.css';
import { getCurrentIdpClientsManagement, deleteRole } from '../../ApiUtils/ApiUtils';
import { KeycloakClient } from '../Management/IdpConfigureForm';
import { Role } from './RoleList';

//export interface Role {
//    name: string,
//    composite: boolean,
//    clientRole: boolean,
//    containerId: string,
//}

interface DuplicateClient {
    clientId: string;
    name: string;
}

const InitialState: { clients: KeycloakClient[] } = {
    clients: [],
}
type State = typeof InitialState;

type RoleDeleteFormProps = {
    realmName: string;
    clientProp: any;
    roleProp: any;
    toggleDialog: (realmClientId?: string, role?: Role, deleted?: boolean) => void;
}

class RoleDeleteForm extends React.Component<RoleDeleteFormProps, State> {

    public constructor(props: RoleDeleteFormProps) {
        super(props);
        this.state = {
            clients: [],
        };
    }

    componentDidMount() {
        this.getClients(this.props.realmName);
    }

    private getClients = (realmName: string) => {
        getCurrentIdpClientsManagement(realmName).then((dataArray) => {
            this.setState({ clients: JSON.parse(dataArray) });
        });
    }

    private handleSubmit = (e: React.ChangeEvent<any>) => {

        document.querySelectorAll<HTMLElement>("[id='" + this.props.roleProp.id + "deleteButton']").forEach(function (elm: HTMLElement) {
            elm.style.display = 'none';
        })
        deleteRole(this.props.realmName, this.props.clientProp.id, this.props.roleProp.name).then((response) => {
            this.props.toggleDialog("", this.props.roleProp, true);
        });
       
    }

    public render() {
        return (
            <>
                <Dialog title={"Please confirm"} onClose={() => this.props.toggleDialog()}>
                    <p style={{ margin: "25px", textAlign: "center" }}>
                        Are you sure you want to delete this role?
                    </p>
                    <DialogActionsBar>
                        <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base cancel-button" onClick={() => this.props.toggleDialog()}>
                            No
                        </button>
                        <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base confirm-button" onClick={this.handleSubmit}>
                            Yes
                        </button>
                    </DialogActionsBar>
                </Dialog>
            </>
        );
    }
}

export default RoleDeleteForm;